module.exports = __webpack_public_path__ + "static/img/yape.0712e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payments/yape.png
// module id = 302
// module chunks = 1